export enum AppState {
  STARTING = 'STARTING',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  PLAYING = 'PLAYING',
  STANDBY = 'STANDBY',
  ERROR = 'ERROR',
}

export type StateListener = (state: AppState) => void;

export class StateController {
  private state: AppState;
  private listeners: StateListener[] = [];

  constructor(initial: AppState) {
    this.state = initial;
  }

  get current(): AppState {
    return this.state;
  }

  subscribe(listener: StateListener): void {
    this.listeners.push(listener);
    listener(this.state);
  }

  set(state: AppState): void {
    if (this.state === state) return;
    this.state = state;
    this.listeners.forEach(l => l(state));
  }
}
